<template>
  <div class="text-center">
    <div class="pt-3">
      <span
        class="text-24-bold"
        style="color: #222222"
      >
        Apakah kamu yakin ingin mentransfer nominal penarikan saldo?
      </span>
      <br>
      <span
        class="text-16-normal"
        style="color: #222222"
      >
        Pilih jawaban anda sekarang!
      </span>
      <br>
      <div class="my-1">
        <BButton
          variant="primary"
          class="mr-1"
          :disabled="disableBtn"
          @click="onFinish"
        >
          <BSpinner
            v-if="isLoading"
            variant="light"
            small
          />
          Yakin
        </BButton>
        <BButton
          variant="outline-primary"
          style="border-color: unset"
          @click="closeModal"
        >
          Tidak
        </BButton>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import { komshipAxiosIns } from '@/libs/axios'

export default {
  components: { BButton, BSpinner },
  props: {
    getDetailWithdrawal: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      idWithdrawal: this.$route.params.slug,
      disableBtn: false,
    }
  },
  methods: {
    async onFinish() {
      this.isLoading = true
      this.disableBtn = true
      const endpoint = `/v2/admin/withdrawal/update/${this.idWithdrawal}`
      const formData = new FormData()
      formData.append('withdrawal_id', this.idWithdrawal)
      await komshipAxiosIns
        .put(endpoint, formData)
        .then(() => {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Success',
              icon: 'CheckIcon',
              text: 'Transfer Saldo Berhasil!',
              variant: 'success',
            },
          }, 2000)
          this.closeModal()
          this.getDetailWithdrawal()
          this.isLoading = true
          this.disableBtn = true
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: err.message,
              variant: 'danger',
            },
          }, 2000)
          this.isLoading = false
          this.disableBtn = true
        })
    },
    closeModal() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-transfer-now')
      })
    },
  },
}
</script>
